/* ════════════════════════════════════════════════════════════════════
   sk-apparel.js — Apparel PDP (Pump Cover tee)
   Two option dimensions (Colour x Size) resolved to a real variant.
   Cart add fires the site cart-drawer events (sk-cart:added / sk-cart:refresh),
   same API as sk-meal.js. Size-guide modal, sticky bar, qty stepper, gallery.
   ════════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  var root = document.querySelector(".sk-apparel-buy");
  if (!root) return;

  var $  = function (s, c) { return (c || root).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || root).querySelectorAll(s)); };
  var money = function (cents) {
    if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, window.theme && theme.moneyFormat);
    return "$" + (cents / 100).toFixed(2);
  };

  /* ── variant data ── */
  var variants = [];
  try { variants = JSON.parse($("[data-sk-ap-variants]").textContent); } catch (e) { variants = []; }

  /* ── current selection, keyed by option position ── */
  var selection = {};
  $$("[data-sk-ap-options] [data-opt-pos]").forEach(function (group) {
    var pos = group.getAttribute("data-opt-pos");
    var on = group.querySelector('[aria-pressed="true"]') || group.querySelector(".on");
    if (on && on.hasAttribute("data-value")) selection[pos] = on.getAttribute("data-value");
  });

  /* ── cart add (mirrors sk-meal.js event API) ── */
  function cartAdd(id, qty) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: parseInt(id, 10), quantity: qty || 1 }] })
    }).then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); });
  }
  function syncOpen() { document.dispatchEvent(new CustomEvent("sk-cart:added", { detail: { open: true } })); }

  /* ── elements ── */
  var idInput   = $("[data-sk-ap-id]");
  var qtyInput  = $("[data-sk-ap-qtyinput]");
  var priceEl   = $("[data-sk-ap-price]");
  var compareEl = $("[data-sk-ap-compare]");
  var addBtn    = $("[data-sk-ap-add]");
  var addLabel  = $("[data-sk-ap-addlabel]");
  var sbPrice   = $("[data-sk-ap-sbprice]");
  var sbSel     = $("[data-sk-ap-sbsel]");
  var addText   = (addBtn && addBtn.getAttribute("data-add-text")) || (addLabel ? addLabel.textContent : "Add to bag");

  /* clean display label for an option value (colour swatches carry a short data-label) */
  function labelFor(pos, value) {
    var btns = $$('[data-opt-pos="' + pos + '"][data-value]');
    for (var i = 0; i < btns.length; i++) {
      if (btns[i].getAttribute("data-value") === value) return btns[i].getAttribute("data-label") || value;
    }
    return value;
  }

  function findVariant(sel) {
    return variants.filter(function (v) {
      return ["1", "2", "3"].every(function (p) {
        var want = sel[p];
        if (want == null) return true;
        return String(v["o" + p]) === String(want);
      });
    })[0];
  }

  /* a value at position `pos` is buyable if some AVAILABLE variant carries it
     while matching every OTHER currently-selected option */
  function valueBuyable(pos, value) {
    return variants.some(function (v) {
      if (!v.available) return false;
      if (String(v["o" + pos]) !== String(value)) return false;
      return Object.keys(selection).every(function (p) {
        if (p === pos) return true;
        return String(v["o" + p]) === String(selection[p]);
      });
    });
  }

  function refresh() {
    // grey out impossible combinations
    $$("[data-sk-ap-options] [data-opt-pos]").forEach(function (group) {
      var pos = group.getAttribute("data-opt-pos");
      $$("[data-value]", group).forEach(function (btn) {
        var buyable = valueBuyable(pos, btn.getAttribute("data-value"));
        btn.classList.toggle("soldout", !buyable);
        btn.disabled = !buyable;
      });
      var sel = $('[data-sk-ap-optsel="' + pos + '"]');
      if (sel && selection[pos] != null) sel.textContent = labelFor(pos, selection[pos]);
    });

    var v = findVariant(selection);
    var available = !!(v && v.available);

    if (v) {
      if (idInput) idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (sbPrice) sbPrice.textContent = money(v.price);
      if (compareEl) {
        if (v.compare > v.price) { compareEl.textContent = money(v.compare); compareEl.style.display = ""; }
        else { compareEl.style.display = "none"; }
      }
      // swap gallery to the variant's image
      if (v.media != null) activateFrame(String(v.media));
    }

    if (addBtn) addBtn.disabled = !available;
    if (addLabel) addLabel.textContent = available ? addText : (v ? "Sold out" : "Choose options");
    if (sbSel) sbSel.textContent = Object.keys(selection).map(function (p) { return labelFor(p, selection[p]); }).join(" · ");
  }

  /* ── option clicks ── */
  $$("[data-sk-ap-options] [data-value]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      if (btn.disabled) return;
      var pos = btn.getAttribute("data-opt-pos");
      selection[pos] = btn.getAttribute("data-value");
      var group = btn.closest(".ap-opt"); /* the option group container, NOT the button (button also has data-opt-pos) */
      $$("[data-value]", group).forEach(function (b) {
        var on = b === btn;
        b.classList.toggle("on", on);
        b.setAttribute("aria-pressed", on ? "true" : "false");
      });
      refresh();
    });
  });

  /* ── gallery ── */
  function activateFrame(mediaId) {
    var frames = $$("[data-sk-ap-gallery] .ap-frame");
    var target = frames.filter(function (f) { return f.getAttribute("data-media-id") === mediaId; })[0];
    if (!target) return;
    frames.forEach(function (f) { f.classList.remove("active"); });
    target.classList.add("active");
    $$("[data-sk-ap-thumb]").forEach(function (t) { t.classList.toggle("on", t.getAttribute("data-sk-ap-thumb") === mediaId); });
  }
  $$("[data-sk-ap-thumb]").forEach(function (t) {
    t.addEventListener("click", function () { activateFrame(t.getAttribute("data-sk-ap-thumb")); });
  });

  /* ── quantity ── */
  var qtyEl = $("[data-sk-ap-qty]");
  var qty = 1;
  $$("[data-sk-ap-step]").forEach(function (b) {
    b.addEventListener("click", function () {
      qty = Math.max(1, qty + parseInt(b.getAttribute("data-sk-ap-step"), 10));
      if (qtyEl) qtyEl.textContent = qty;
      if (qtyInput) qtyInput.value = qty;
    });
  });

  /* ── toast ── */
  var toast = $("[data-sk-ap-toast]");
  var toastTimer = null;
  function showToast(msg) {
    if (!toast) return;
    var m = $("[data-sk-ap-toastmsg]"); if (m && msg) m.textContent = msg;
    toast.classList.add("show");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove("show"); }, 3000);
  }

  /* ── add to bag ── */
  function doAdd() {
    var v = findVariant(selection);
    if (!v || !v.available) { refresh(); return; }
    if (addBtn) addBtn.classList.add("loading");
    cartAdd(v.id, qty).then(function () {
      showToast("Added to your bag");
      syncOpen();
    }).catch(function (e) {
      showToast((e && e.description) || "Couldn't add that one");
    }).then(function () {
      if (addBtn) addBtn.classList.remove("loading");
    });
  }
  var form = $("#sk-apparel-form");
  if (form) form.addEventListener("submit", function (e) { e.preventDefault(); doAdd(); });
  var sbAdd = $("[data-sk-ap-sbadd]");
  if (sbAdd) sbAdd.addEventListener("click", function () {
    if (findVariant(selection)) doAdd();
    else { window.skScrollToEl && window.skScrollToEl($(".ap-buy-col"), "center"); }
  });

  /* ── size guide modal ── */
  var sg = $("[data-sk-ap-sg]");
  var lastFocus = null;
  function openSg() { if (!sg) return; lastFocus = document.activeElement; sg.hidden = false; document.body.classList.add("ap-sg-open"); var x = $(".ap-sg__x", sg); if (x) x.focus(); }
  function closeSg() { if (!sg) return; sg.hidden = true; document.body.classList.remove("ap-sg-open"); if (lastFocus) lastFocus.focus(); }
  $$("[data-sk-ap-sizeguide]").forEach(function (b) { b.addEventListener("click", openSg); });
  $$("[data-sk-ap-sgclose]").forEach(function (b) { b.addEventListener("click", closeSg); });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape" && sg && !sg.hidden) closeSg(); });

  refresh();
})();
